import { SidebarContentTypes } from "@/apps/merchant3/types/in-console/SidebarContentTypes";

export type SideBarState = {
  sidebarIsOpen: boolean;
  contentToShow: undefined | SidebarContentTypes;
};

const mutations = {
  SET_IN_CONSOLE_MESSAGES_SIDEBAR_STATE: (
    state: SideBarState,
    payload: Partial<SideBarState>
  ): void => {
    state.sidebarIsOpen = payload.sidebarIsOpen ?? false;
    state.contentToShow =
      payload.contentToShow ?? SidebarContentTypes.IN_CONSOLE_TRAINING;
  },
};
export default mutations;
